<template>
  <div class="logo-box d-flex gap-3 align-items-center" v-if="!isDelegue">
    <img :src="veterinaire.image && veterinaire.image.path ? veterinaire.image.path : defaultLogo" />
    <h3>{{ $t("menu_sidebar.logo_title", { lastName: veterinaire.lastName }) }}</h3>
  </div>
  <div class="logo-box d-flex gap-3 align-items-center" v-else>
    <img :src="veterinaire.image && veterinaire.image.path ? veterinaire.image.path : defaultLogo" />
    <h3>{{ $t("menu_sidebar.logo_delegue_title", { lastName: veterinaire.lastName }) }}</h3>
  </div>

  <div class="dashboard-menu">
    <ul class="list-group">
      <!-- <li class="list-group-item" v-if="!isDelegue">
        <a href="#" @click.prevent="changeTab('tableau_bord')" :class="{ active: activeTab === 'tableau_bord' }">{{
          $t("menu_sidebar.dashboard")
        }}</a>
      </li> -->
      <li class="list-group-item">
        <a
          href="#"
          @click.prevent="changeTab('informations_personnels')"
          :class="{ active: activeTab === 'informations_personnels' }"
          >{{ $t("menu_sidebar.personal_info") }}</a
        >
      </li>
      <li class="list-group-item">
        <a href="#" @click.prevent="changeTab('mes_contacts')" :class="{ active: activeTab === 'mes_contacts' }">{{
          $t("menu_sidebar.contacts")
        }}</a>
      </li>
      <li class="list-group-item" v-if="!isDelegue">
        <a
          href="#"
          @click.prevent="changeTab('adresse_livraison')"
          :class="{ active: activeTab === 'adresse_livraison' }"
          >{{ $t("menu_sidebar.delivery_addresses") }}</a
        >
      </li>
      <li class="list-group-item" v-if="!isDelegue">
        <a href="#" @click.prevent="changeTab('commandes')" :class="{ active: activeTab === 'commandes' }">{{
          $t("menu_sidebar.orders")
        }}</a>
      </li>
      <li class="list-group-item" v-if="!isDelegue">
        <a href="#" @click.prevent="changeTab('factures')" :class="{ active: activeTab === 'factures' }">{{
          $t("menu_sidebar.invoices")
        }}</a>
      </li>
      <li class="list-group-item">
        <a href="#" @click.prevent="changeTab('documents')" :class="{ active: activeTab === 'documents' }">{{
          $t("menu_sidebar.documents")
        }}</a>
      </li>
      <li class="list-group-item" v-if="isDelegue">
        <a href="#" @click.prevent="changeTab('widget')" :class="{ active: activeTab === 'widget' }">{{
          $t("menu_sidebar.widget")
        }}</a>
      </li>

      <li class="list-group-item" v-if="veterinaire.hasSubscription">
        <div
          @click="toggleDropdown('platforme')"
          style="cursor: pointer"
          class="d-flex justify-content-between align-items-center btn-submenu"
        >
          {{ $t("menu_sidebar.platform") }}
          <i :class="['ti', isPlatformeDropdownOpen ? 'ti-angle-up' : 'ti-angle-down']"></i>
        </div>
        <ul v-if="isPlatformeDropdownOpen" class="list-group sub-menu mt-3">
          <li class="list-group-item">
            <a
              href="#"
              @click.prevent="changeTab('commandes_clients')"
              :class="{ activeDropdown: activeTab === 'commandes_clients' }"
              >{{ $t("menu_sidebar.platform_items.client_orders") }}</a
            >
          </li>
          <li class="list-group-item">
            <a
              href="#"
              @click.prevent="changeTab('facture_clients')"
              :class="{ activeDropdown: activeTab === 'facture_clients' }"
              >{{ $t("menu_sidebar.platform_items.facture_client") }}</a
            >
          </li>
          <li class="list-group-item">
            <a href="#" @click.prevent="changeTab('catalogue')" :class="{ activeDropdown: activeTab === 'catalogue' }">{{
              $t("menu_sidebar.platform_items.catalog")
            }}</a>
          </li>
          <li class="list-group-item">
            <a href="#" @click.prevent="changeTab('frais_port')" :class="{ activeDropdown: activeTab === 'frais_port' }">{{
              $t("menu_sidebar.platform_items.shipping_fees")
            }}</a>
          </li>
          <li class="list-group-item">
            <a
              href="#"
              @click.prevent="changeTab('offre_fidelete')"
              :class="{ activeDropdown: activeTab === 'offre_fidelete' }"
              >{{ $t("menu_sidebar.platform_items.loyalty_offer") }}</a
            >
          </li>
          <!-- <li class="list-group-item">
            <a href="#" @click.prevent="changeTab('presentation')" :class="{ active: activeTab === 'presentation' }">{{
              $t("menu_sidebar.platform_items.presentation")
            }}</a>
          </li> -->
          <li class="list-group-item">
            <a
              href="#"
              @click.prevent="changeTab('communication')"
              :class="{ activeDropdown: activeTab === 'communication' }"
              >{{ $t("menu_sidebar.platform_items.communication") }}</a
            >
          </li>
          <li class="list-group-item">
            <a
              href="#"
              @click.prevent="changeTab('mollie_status')"
              :class="{ activeDropdown: activeTab === 'mollie_status' }"
              >{{ $t("menu_sidebar.platform_items.mollie_payments") }}</a
            >
          </li>
        </ul>
      </li>

      <li class="list-group-item">
        <div
          @click="toggleDropdown('ration')"
          style="cursor: pointer"
          class="d-flex justify-content-between align-items-center btn-submenu"
        >
          {{ $t("menu_sidebar.ration_calc") }}
          <i :class="['ti', isRationDropdownOpen ? 'ti-angle-up' : 'ti-angle-down']"></i>
        </div>
        <ul v-if="isRationDropdownOpen" class="list-group sub-menu mt-3">
          <li class="list-group-item">
            <a
              href="#"
              @click.prevent="changeTab('calcul_ration')"
              :class="{ activeDropdown: activeTab === 'calcul_ration' }"
              >{{ $t("menu_sidebar.ration_items.my_calculations") }}</a
            >
          </li>
          <li class="list-group-item">
            <a
              href="#"
              @click.prevent="changeTab('parametres_calcul')"
              :class="{ activeDropdown: activeTab === 'parametres_calcul' }"
              >{{ $t("menu_sidebar.ration_items.params") }}</a
            >
          </li>
          <li class="list-group-item">
            <a href="#" @click.prevent="changeTab('rappel')" :class="{ activeDropdown: activeTab === 'rappel' }">{{
              $t("menu_sidebar.ration_items.reminders")
            }}</a>
          </li>
        </ul>
      </li>
    </ul>
  </div>

  <div class="logout-block">
    <a href="">
      <span @click.prevent="Logout"> <img :src="logout" /> {{ $t("menu_sidebar.logout") }}</span>
    </a>
  </div>
</template>

<script>
  import logout from "@/assets/images/logout.svg";
  import defaultLogo from "@/assets/images/doctor.svg";
  import { useRegisterStore } from "@/stores/register";
  import AuthService from "@/services/authService";

  export default {
    name: "CompteUser",
    props: {
      activeTab: String,
    },
    emits: ["change-tab"],
    computed: {
      isOpen() {
        return this.manualOpen || ["calcul_ration", "rappel"].includes(this.activeTab);
      },
      veterinaire() {
        return this.registerStore.Veterinaire;
      },
      loading() {
        return this.registerStore.loading;
      },
      isDelegue() {
        return AuthService.isDelegue();
      },
      isPlatformeDropdownOpen() {
        const platformeTabs = [
          "commandes_clients",
          "facture_clients",
          "catalogue",
          "frais_port",
          "offre_fidelete",
          "communication",
          "mollie_status",
        ];
        return this.dropdowns.platforme || platformeTabs.includes(this.activeTab);
      },
      isRationDropdownOpen() {
        const rationTabs = ["calcul_ration", "parametres_calcul", "rappel"];
        return this.dropdowns.ration || rationTabs.includes(this.activeTab);
      },
    },
    data() {
      return {
        registerStore: null,
        logout,
        defaultLogo,
        manualOpen: false,
        openDropdown: null,
        dropdowns: {
          ration: false,
          documents: false,
          platforme: false,
        },
      };
    },
    mounted() {
      this.registerStore = useRegisterStore();
      this.registerStore.fetchVeterinaire();
    },
    created() {
      this.registerStore = useRegisterStore();
    },
    methods: {
      changeTab(tab) {
        this.$emit("change-tab", tab);
      },
      handleSubmit() {
        this.form.search = "";
      },
      toggleDropdown(name) {
        this.dropdowns[name] = !this.dropdowns[name];
      },
      Logout() {
        localStorage.removeItem("token");
        localStorage.clear();
        this.$router.push({ name: "Home" });
      },
    },
  };
</script>

<style scoped>
  .list-group-item a.active {
    color: #ffffff;
    font-weight: bold;
    background-color: #1e347d;
  }
  .list-group-item a.activeDropdown {
    color: #1e347d;
    font-weight: bold;
    background-color: #ffffff;
  }
</style>
